import { gql } from '@apollo/client'

export const CREATE_WHY_YOU_LOVE_TEXT_MUTATION = gql`
  mutation CreateUserStoryText($createUserStoryTextInput: CreateUserStoryTextInput!) {
    createUserStoryText(createUserStoryTextInput: $createUserStoryTextInput) {
      id
    }
  }
`
export const MOMENT_CLAIM_MUTATION = gql`
  mutation momentClaim($momentClaimInput: MomentClaimInput!) {
    momentClaim(input: $momentClaimInput) {
      code
      message
      success
    }
  }
`
